module.exports = __webpack_public_path__ + "img/hero-shape-2.494a8698.png";